import { HHStack, HHTypography } from '@hinge-health/react-component-library';
import { CONFIGURATION_STATUS_LABELS } from '../constants/partner-data-gateway.constant';
import { Configuration } from '../domain/types';
import { StatusChip } from './status-chip';

export const CONFIGURATION_HEADER_TEST_ID = 'pdg-configuration-header';
export const CONFIGURATION_HEADER_NAME_TEST_ID =
  'pdg-configuration-header-name';
export const CONFIGURATION_HEADER_STATUS_TEST_ID =
  'pdg-configuration-header-status-chip';
export const CONFIGURATION_HEADER_PROVIDER_TEST_ID =
  'pdg-configuration-header-provider';
export const CONFIGURATION_HEADER_TIMESTAMPS_TEST_ID =
  'pdg-configuration-header-timestamps';

export interface ConfigurationHeaderProps {
  configuration: Configuration;
}

/**
 * Identity band for a single configuration: what it is called, what state
 * it is in, whose data it matches, and when it last moved. Timestamps stay
 * as the raw ISO values PDGS returned — an operator comparing a
 * configuration against an ingestion needs the exact instant, not "2 days
 * ago".
 */
export const ConfigurationHeader = ({
  configuration,
}: ConfigurationHeaderProps): JSX.Element => (
  <HHStack gap={1} data-testid={CONFIGURATION_HEADER_TEST_ID}>
    <HHStack direction="row" gap={2} alignItems="center" flexWrap="wrap">
      <HHTypography
        hhVariant="variant-bypass"
        variant="h5"
        component="h1"
        data-testid={CONFIGURATION_HEADER_NAME_TEST_ID}
        sx={{ fontSize: 20, fontWeight: 600, wordBreak: 'break-word' }}
      >
        {configuration.name}
      </HHTypography>
      <StatusChip
        status={configuration.status}
        label={CONFIGURATION_STATUS_LABELS[configuration.status]}
        testId={CONFIGURATION_HEADER_STATUS_TEST_ID}
      />
    </HHStack>
    <HHTypography
      hhVariant="variant-bypass"
      variant="body2"
      color="text.secondary"
      data-testid={CONFIGURATION_HEADER_PROVIDER_TEST_ID}
    >
      {`Provider: ${configuration.dataProvider}`}
    </HHTypography>
    <HHTypography
      hhVariant="variant-bypass"
      variant="body2"
      color="text.secondary"
      data-testid={CONFIGURATION_HEADER_TIMESTAMPS_TEST_ID}
    >
      {`Created ${configuration.createdAt} · Updated ${configuration.updatedAt}`}
    </HHTypography>
  </HHStack>
);
